
<template>
  <v-app id="onIdit">
    <v-main>
    <v-container fluid>  
    <v-card>
      
      Nr: {{idit.idit_nr}}  

      <span v-for="(idittaalRecord,i) in idit.idittaal" :key="i">
       <br>
       {{idittaalRecord.taal_code}}  <v-btn class="primary ma-2" small @click="saveIdittaal(idittaalRecord)">Save</v-btn><br>
       <v-textarea v-model="idittaalRecord.idittaal_oms" :value=idittaalRecord.idittaal_oms rows="1" label="Translation" spellcheck="false"></v-textarea>
       <br>
      </span>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['idit_encrid'],
  data() {
    return {
      idit: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/idit/getIdit.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getIdit"
          },
          getIdit: {
             idit_encrid: this.idit_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.idit = res.data.getIdit;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    saveIdittaal(idittaal) { 
      this.$axios
        .post("ares/json/ares/syst/ref/idit/saveIdittaal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveIdittaal"
          },
          saveIdittaal: {
            idittaal: idittaal
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveIdittaal.text,
              color: res.data.saveIdittaal.color
            });
          }
        })
    }
  }  

};

</script> 
